var _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircles = function SvgCircles(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1730,
    height: 1080,
    viewBox: "0 0 1730 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 865.001,
    cy: 540.001,
    r: 664.057,
    stroke: "#0F2B55",
    strokeWidth: 1.11326
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 865,
    cy: 539.998,
    r: 764.25,
    stroke: "#0F2B55",
    strokeWidth: 1.11326
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 865,
    cy: 540,
    r: 864.443,
    stroke: "#0F2B55",
    strokeWidth: 1.11326
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "circles.0e32ea5ad016b0b1b1a349c8beb9864c.svg";